module.exports = __webpack_public_path__ + "static/media/header_cart_icon.f1bc9bf6.svg";